import React from "react";
// import TouchIcon from "./../../Images/dnd_dots.png";
import { useAuth } from "../../Context/AuthContext";
import { useDispatch, useSelector } from "react-redux";
import { getErrorMessage } from "../../Redux/Actions/errorMessage";

//redux
// import { useSelector, useDispatch } from "react-redux";
//test windowsize
// import useWindowSize from "../use-window-size";

const CardMobile = ({ data }) => {
  const { editLocalData, editLocalNumberData,deleteLocalData  } = useAuth();

  const currentPage = useSelector((state) => state.activePage);

  const dispatch = useDispatch();

  // function handleEdit(e, id) {
  //   editLocalData(e, id);
  // }
  function handleEdit(e, id) {
    const regex = /^(\d+(\.\d{0,5})?|\.?\d{1,2})$/;
    if (
      e.target.name.includes("price") ||
      e.target.name.includes("variableCost") ||
      e.target.name.includes("workHours") ||
      e.target.name.includes("volumeYear")
    ) {
      if (e.target.value.match(regex)) {
        editLocalNumberData(e, id);
      } else {
        dispatch(
          getErrorMessage(
            `Felaktig inmatning i ${currentPage}, var god skriv in siffror!`
          )
        );
        const delayEditData = setTimeout(() => {
          dispatch(getErrorMessage(""));
        }, 5000);
        return () => clearTimeout(delayEditData);
      }
    } else {
      editLocalData(e, id);
    }
  }

  function handleDelete(id) {
    deleteLocalData(id);
  }

  //calculations
  //täckningsbidrag = Försäljn.pris/per styck - Rörlig kostn/per styck
  function grossMargin(price, variableCost) {
    let a = parseFloat(price);
    let b = parseFloat(variableCost);
    const result = a - b;
    if (isNaN(result) || !isFinite(result)) {
      return "";
    } else {
      return result.toFixed(2);
    }
  }
  // täckningsgrad = (täckningsbidrag * 100) / Försäljn.pris/per styck
  function coverage(price, variableCost) {
    let a = parseFloat(price);
    let b = parseFloat(variableCost);

    const result = ((a - b) * 100) / a;
    if (isNaN(result) || !isFinite(result)) {
      return "";
    } else {
      //two decimals
      return result.toFixed(1);
    }
  }
  // täckningsbidrag per timme (täckningsbidrag / arbetstid per timme)
  function grossMarginHour(price, variableCost, workHour) {
    let a = parseFloat(price);
    let b = parseFloat(variableCost);
    let c = parseFloat(workHour);
    let result = (a - b) / c;
    if (isNaN(result) || !isFinite(result)) {
      return "";
    } else {
      //hide decimal if none
      if (result % 1 === 0) {
        return (result = parseInt(result, 10));
      } else {
        return (result = parseFloat(result, 10).toFixed(1));
      }
    }
  }
  // årsförsäljning
  function annualSales(price, volumeYear) {
    let a = parseFloat(price);
    let b = parseFloat(volumeYear);
    const result = a * b;
    if (isNaN(result) || !isFinite(result)) {
      return "";
    } else {
      return result;
    }
  }

  // årstäckningsbidrag
  function yearGrossMargin(price, variableCost, volumeYear) {
    let a = parseFloat(price);
    let b = parseFloat(variableCost);
    let c = parseFloat(volumeYear);
    const grossMargin = a - b;
    const result = grossMargin * c;
    if (isNaN(result) || !isFinite(result)) {
      return "";
    } else {
      return result;
    }
  }

  return (
    <div className="container-input-mobile">
      <label className="label-mobile">Affärsområde/ Produktgrupp</label>
      <input
        type="text"
        className="input-mobile-long"
        name="category"
        defaultValue={data.object.category}
        maxLength="30"
        autoComplete="off"
        onChange={(e) => handleEdit(e, data.id)}
      />
      <label className="label-mobile">Produkt (Vara eller Tjänst)</label>
      <input
        type="text"
        className="input-mobile-long"
        name="product"
        defaultValue={data.object.product}
        maxLength="30"
        autoComplete="off"
        onChange={(e) => handleEdit(e, data.id)}
      />
      <div className="container-input-mobile-small-input">
        <div className="input-mobile-small-input">
          <label className="label-mobile">Försäljn. pris/styck</label>
          <input
            type="text"
            className="input-mobile"
            name="price"
            defaultValue={data.object.price === "0" ? "" : data.object.price}
            maxLength="7"
            autoComplete="off"
            onChange={(e) => handleEdit(e, data.id)}
          />
        </div>
        <div className="input-mobile-small-input">
          <label className="label-mobile">Rörlig kostn./styck</label>
          <input
            type="text"
            className="input-mobile"
            name="variableCost"
            defaultValue={
              data.object.variableCost === "0" ? "" : data.object.variableCost
            }
            maxLength="7"
            autoComplete="off"
            onChange={(e) => handleEdit(e, data.id)}
          />
        </div>
      </div>
      <div className="container-input-mobile-small-input">
        <div className="input-mobile-small-input">
          <label className="label-mobile">Täcknings- bidrag</label>
          <output className="output-mobile" name="grossMargin">
            {/* {Math.round(grossMargin(data.object.price, data.object.variableCost))} */}
            {grossMargin(data.object.price, data.object.variableCost) % 1 === 0
              ? parseInt(
                  grossMargin(data.object.price, data.object.variableCost),
                  10
                )
              : parseFloat(
                  grossMargin(data.object.price, data.object.variableCost),
                  10
                ).toFixed(1)}
          </output>
        </div>
        <div className="input-mobile-small-input">
          <label className="label-mobile">Täcknings- grad</label>
          <output className="output-mobile" name="coverage">
            {Math.round(
              coverage(data.object.price, data.object.variableCost) * 100
            ) /
              100 +
              " %"}
          </output>
        </div>
      </div>
      <div className="container-input-mobile-small-input">
        <div className="input-mobile-small-input">
          <label className="label-mobile">
            Arbetad tid
            tim/st.
          </label>
          <input
            type="text"
            className="input-mobile"
            name="workHours"
            defaultValue={
              data.object.workHours === "0" ? "" : data.object.workHours
            }
            maxLength="7"
            autoComplete="off"
            onChange={(e) => handleEdit(e, data.id)}
          />
        </div>
        <div className="input-mobile-small-input">
          <label className="label-mobile">Täcknings-bidrag/tim</label>
          <output className="output-mobile" name="grossMarginHour">
            {grossMarginHour(
              data.object.price,
              data.object.variableCost,
              data.object.workHours
            )}
          </output>
        </div>
      </div>
      <div className="container-input-mobile-small-input">
        <div className="input-mobile-small-input">
      <label className="label-mobile">Årsvolym antal styck</label>
      <input
        type="text"
        className="input-mobile"
        name="volumeYear"
        defaultValue={
          data.object.volumeYear === "0" ? "" : data.object.volumeYear
        }
        maxLength="7"
        autoComplete="off"
        onChange={(e) => handleEdit(e, data.id)}
      />
      </div>
        <div className="input-mobile-small-input">
      <label className="label-mobile">Års-försäljning</label>
      <output className="output-mobile" name="annualSales">
        {Math.round(annualSales(data.object.price, data.object.volumeYear))}
      </output>
      </div>
      </div>
      <label>Års-täcknings-bidrag</label>
      <output className="output-mobile" name="annualContribution">
        {Math.round(
          yearGrossMargin(
            data.object.price,
            data.object.variableCost,
            data.object.volumeYear
          )
        )}
      </output>

      <button className="button-delete" onClick={() => handleDelete(data.id)}>Ta bort vara/produkt</button>
    </div>
  );
};

export default CardMobile;
